import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {
  ASSISTANT_HOME_PATH,
  isAssistantPathAllowed,
  isAssistantRole,
} from "../../constants/assistantAccess";

/**
 * React Router v6 guard.
 * Wrap protected route elements with <RequireAuth>...</RequireAuth>.
 */
export const RequireAuth = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userData = useSelector((state) => state.user.userData);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (isAssistantRole(userData) && !isAssistantPathAllowed(location.pathname)) {
    return <Navigate to={ASSISTANT_HOME_PATH} replace />;
  }

  return children;
};

export default RequireAuth;
